import { useEffect } from 'react';

/**
 * Custom hook that calls a callback function when the Escape key is pressed
 * @param callback - Function to call when Escape is pressed
 */
export const useEscapeKey = (callback: () => void) => {
  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        callback();
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [callback]);
};
